import constants from '@playcastdotio/GlobalConfig';
import type { TrustedPartnersConfig } from '@playcastdotio/Messaging';

/** Hard-coded Imgur logos used when the API is empty or unavailable. */
export const FALLBACK_PARTNER_LOGOS = [
  'https://i.imgur.com/hriWZuN.png',
  'https://i.imgur.com/SRG5ahW.png',
  'https://i.imgur.com/r5cy7YY.png',
  'https://i.imgur.com/KMYvQWD.png',
];

const ensureTrailingSlash = (url: string) => (url.endsWith('/') ? url : `${url}/`);

export function resolvePartnerLogoUrls(
  apiLogos: { imageUrl: string }[] | null | undefined,
): string[] {
  if (apiLogos && apiLogos.length > 0) {
    return apiLogos.map((logo) => logo.imageUrl);
  }
  return FALLBACK_PARTNER_LOGOS;
}

export async function fetchTrustedPartnerLogoUrls(): Promise<string[]> {
  const baseUrl = ensureTrailingSlash(constants.REALTIME_API_BASE_URL);

  try {
    const response = await fetch(`${baseUrl}realtime/marketing/trusted-partners`);
    if (!response.ok) {
      console.warn('[TrustedPartners] Request failed', response.status, response.statusText);
      return FALLBACK_PARTNER_LOGOS;
    }

    const payload = (await response.json()) as {
      success?: boolean;
      data?: TrustedPartnersConfig;
    };

    if (!payload?.success || !payload.data) {
      return FALLBACK_PARTNER_LOGOS;
    }

    return resolvePartnerLogoUrls(payload.data.logos);
  } catch (error) {
    console.warn('[TrustedPartners] Failed to load logos', error);
    return FALLBACK_PARTNER_LOGOS;
  }
}
